import * as React from "react"

import { cn } from "@/lib/utils"

const BASE = "flex w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"

// الحقول النصية المفتوحة تتمدد تلقائيًا مع طول ما يُكتب (حتى يقرأ المستخدم كل ما أدخله) — بقية الأنواع تبقى حقولًا عادية
const GROW_TYPES = new Set([undefined, "text", "search", "url"])

const fit = (el) => {
  if (!el) return
  el.style.height = "auto"
  const h = el.scrollHeight
  if (h > 0) el.style.height = `${h}px`
}

const GrowInput = React.forwardRef(({ className, onKeyDown, onInput, value, ...props }, ref) => {
  const inner = React.useRef(null)
  const setRef = (el) => {
    inner.current = el
    if (typeof ref === "function") ref(el)
    else if (ref) ref.current = el
  }
  React.useLayoutEffect(() => { fit(inner.current) }, [value])
  React.useEffect(() => {
    const el = inner.current
    if (!el || typeof ResizeObserver === "undefined") return
    const ro = new ResizeObserver(() => fit(el))
    ro.observe(el)
    return () => ro.disconnect()
  }, [])
  return (
    <textarea
      ref={setRef}
      rows={1}
      value={value}
      className={cn(BASE, "min-h-9 resize-none overflow-hidden leading-6 whitespace-pre-wrap break-words", className)}
      onInput={(e) => { fit(e.currentTarget); onInput?.(e) }}
      onKeyDown={(e) => {
        onKeyDown?.(e)
        if (e.key === "Enter" && !e.shiftKey && !e.defaultPrevented) {  // يتصرف كحقل عادي: Enter يرسل النموذج ولا يضيف سطرًا
          e.preventDefault()
          e.currentTarget.form?.requestSubmit?.()
        }
      }}
      {...props} />
  )
})
GrowInput.displayName = "GrowInput"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (GROW_TYPES.has(type)) return <GrowInput ref={ref} className={className} {...props} />
  return (
    <input
      type={type}
      className={cn(BASE, "h-9", className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
